"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    registerDevice: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.REGISTER_DEVICE,
        onSuccess: function (draftState, action) {
            var _a;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.registerDevice;
        },
    })), api_1.createApiInitialState(null)),
    devices: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_DEVICES,
        onSuccess: function (draftState, action) {
            var _a, _b;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.devices;
        },
    })), api_1.createApiInitialState([])),
    deviceSessions: api_1.createCustomModuleReducer(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_DEVICE_SESSIONS,
        onSuccess: function (draftState, action) {
            var _a, _b, _c;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.experience) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.deviceSessions;
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SIGN_OUT_DEVICE,
        onSuccess: function (draftState, action) {
            var deviceTypes = action.meta.deviceTypes;
            if (Array.isArray(deviceTypes) && draftState.data) {
                draftState.data = draftState.data.filter(function (session) { return !deviceTypes.includes(session.deviceType); });
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.SIGN_OUT_ALL_DEVICES,
        onSuccess: function (draftState) {
            // eslint-disable-next-line no-param-reassign
            draftState.data = [];
        },
    })), api_1.createApiInitialState([])),
    deactivateDevice: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.DEACTIVATE_DEVICE,
        onSuccess: function (draftState, action) {
            var _a;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.deactivateDevice;
        },
    })), api_1.createApiInitialState(null)),
    updateDeviceName: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.UPDATE_DEVICE_NAME,
        onSuccess: function (draftState, action) {
            var _a;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.updateDeviceName;
        },
    })), api_1.createApiInitialState(null)),
    playbackDevice: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_PLAYBACK_DEVICE] = function (state, action) { return action.payload; },
        _a), null),
    serialNumber: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_SERIAL_NUMBER] = function (state, action) { return action.payload; },
        _b), null),
    signOutDevice: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.SIGN_OUT_DEVICE,
        onSuccess: function (draftState, action) {
            var _a;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.signOutDevices;
        },
    })), (_c = {}, _c[constants_1.RESET_SIGN_OUT_DEVICE] = function () { return api_1.createApiInitialState(null); }, _c)), api_1.createApiInitialState(null)),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map